<!-- XXXX签名 -->
<template>
	<div>
		<img class="icon" src="../assets/img/finish.png" alt="" />
		<div class="tips">电子签名完成，请返回电脑端继续操作！</div>
	</div>
</template>

<script>
	import {
		fileUpload,insertPic
	} from "@/api";
	export default {
		name: 'BloodRegisterSign',
		components: {},

		data() {
			return {
				// ...
				codeTime: '',
				uploadFlag: true,
				inputData: {}, // 该数据中 cxmjView 为需要签名的人员姓名
				nameIndex: 0, // 当前签名为第几个人签名
				signFileList: [] // 签名图片列表
			}
		},

		computed: {
			nameList() {
				return this.inputData.cxmjView ? this.inputData.cxmjView.split(',') : [] // 需要有多个签名
			}
		},

		watch: {},

		created() {
			

		},

		methods: {
			
			
			sureSignHandler(data) {
				var that = this
				console.log(that.uploadFlag)
				if (!this.uploadFlag) {
					console.log('二维码已过期，请重新刷新并扫码')
					let instance = that.$toast({
						message: '二维码已过期，请重新刷新并扫码',
						className:'toastClass',
						position: "bottom",
						// iconClass: "icon icon-success",
						duration: 2000
					});
					return
				}
				const formData = new FormData(); // 下面有备注
				formData.append('file', data);
				fileUpload(formData).then((res) => {
					console.log(res)
					if (res.data.success) {
						let instance = that.$toast({
							message: '提交成功',
								className:'toastClass',
							position: "bottom",
							// iconClass: "icon icon-success",
							duration: 2000
						});
						that.submitHandler(res.data.pic_url)


					} else {
						let instance = that.$toast({
							message: '提交失败',
								className:'toastClass',
							position: "bottom",
							// iconClass: "icon icon-success",
							duration: 2000
						});
					}
				});
			},

			submitHandler(url) {
				let obj = {
					actionId: this.$route.query.actionId,
					picUrl: url,
					picType: 41, //文件类型
					fileName: 'signPic', //文件名
				}
				insertPic(obj).then((res) => {
					if (res.data.status) {
						let instance = that.$toast({
							message: '提交成功',
							position: "bottom",
								className:'toastClass',
							// iconClass: "icon icon-success",
							duration: 2000
						});
				
				
				
					} else {
						that.$toast({
							message: res.data.msg,
							position: "bottom",
								className:'toastClass',
							duration: 2000
						});
					}
				});
			
			}
		}
	}
</script>

<style lang='scss' scoped>
	
	.icon{
		width: 73px;
		height: 62px;
		transform: rotate(90deg) translateX(370px) translateY(-180px);
		margin-bottom: 18px;
	}
	.tips{
		transform: rotate(90deg)  translateX(370px) translateY(40px);
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #333333;
		line-height:23px;
		text-align: left;
		font-style: normal;
	}
</style>


// WEBPACK FOOTER //
// success.vue?15b7e11a